import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CreateProjectDropdown from '../../../components/DropdownStyle/CreateProjectDropdown';
import Select from '../../../components/ReactSelectDropdown';
import { filterOption } from '../../../components/ReactSelectDropdown/ReactSelectDropdown';
import SearchWithButton from '../../../components/Search/SearchWithButton';
import { ButtonIcon, ColoredButtonWithIcon } from '../../../styledComponents/buttons';
import tickIcon from '../../../assets/img/icons/tick_2.svg';
import crossIcon from '../../../assets/img/icons/cancel-red.svg';
import {
  CommonGrid,
  FilterLabel,
  InputField,
  InputWithLabelSection,
} from '../../../styledComponents/common';
import { FilterContainer } from '../../../styledComponents/tasks';
import ButtonTextLoader from 'components/Loaders/ButtonTextLoader';

const PendingFilters = props => {
  const { t } = useTranslation();
  const [officeOptions, setOfficeOptions] = useState([]);
  const [selectedEmployeeType, setSelectedEmployeeType] = useState(null);
  const [employeeTypeOptions, setEmployeeTypeOptions] = useState(
    [
      {
        label: t('approve'),
        value: 'Approve',
      },
      {
        label: t('reject'),
        value: 'Reject',
      },
    ]
  );
  const [selectedStatus, setSelectedStatus] = useState(
    {
      label: t('pending'),
      value: 'pending',
    }
  );

  const {
    getOfficesShortList,
    officesShortList,
    selectedOffice,
    selectOffice,
    handleSearchByName,
    handleClearSearch,
    searchTerm,
    onSearchTermChange,
    userCodeSearchTerm,
    onUserCodeSearchTermChange,
    handleSearchByUserCode,
    handleClearUserCodeSearch,
    selectedRole,
    onRoleChange,
    selectedMembers,
    bulkUpdateFromPendingRequests,
    bulkUpdateFromPendingRequestsLoading,
  } = props;

  const statusOptions = [
    {
      label: t('pending'),
      value: 'pending',
    },
    {
      label: t('approved'),
      value: 'approved',
    },
    {
      label: t('declined'),
      value: 'declined',
    },
  ];

  useEffect(() => {
    getOfficesShortList();
  }, []);

  useEffect(() => {
    if (officesShortList && officesShortList.length > 0) {
      let newArr = [
        {
          label: t('all_offices'),
          value: null,
        },
      ];
      officesShortList.forEach((office, i) => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      setOfficeOptions(newArr);
    }
  }, [officesShortList]);

  const handleApplyFilter = (status = null) => {
    console.log("status", status, selectedEmployeeType, selectedMembers)
    if (selectedMembers.length === 0) return;
    if (localStorage.getItem('user_role') === 'admin' && selectedEmployeeType){
      if (selectedEmployeeType.value === 'Approve') {
        bulkUpdateFromPendingRequests(selectedMembers, 'approve');
      } else if (selectedEmployeeType.value === 'Reject') {
        bulkUpdateFromPendingRequests(selectedMembers, 'reject');
      }
    }
    if (["gm", "agm"].includes(localStorage.getItem('user_role')) && selectedMembers.length > 0 && status) {
      bulkUpdateFromPendingRequests(selectedMembers, status);
    }
  };

  return (
    <FilterContainer
      columns={
        localStorage.getItem('user_role') === 'admin'
          ? `160px 340px 250px 160px ${selectedMembers?.length > 0 && selectedEmployeeType ? '360px' : '160px'}`
          : '340px 250px 160px 160px'
      }
      gap="15px"
    >
      {localStorage.getItem('user_role') === 'admin' && (
        <InputWithLabelSection>
          <FilterLabel>{t('office')}</FilterLabel>

          <Select
            isSearchable
            value={selectedOffice}
            options={officeOptions}
            placeholder="Select Office..."
            onChange={e => {
              console.log("e", e)
              selectOffice(e);
            }}
            styles={CreateProjectDropdown()}
            // clearable
            filterOption={filterOption}
          />
        </InputWithLabelSection>
      )}
      <SearchWithButton
        itemName={""}
        label={t('search_member')}
        searchTermName={`${t('member_name')} ${t('or_email')}`}
        searchInput={searchTerm}
        onInputChange={onSearchTermChange}
        handleSearch={handleSearchByName}
        handleClearSearch={handleClearSearch}
        fontSize="12.5px"
      />
      <SearchWithButton
        itemName={""}
        label={t('search_member')}
        searchTermName={t('user_id')}
        searchInput={userCodeSearchTerm}
        onInputChange={onUserCodeSearchTermChange}
        handleSearch={handleSearchByUserCode}
        handleClearSearch={handleClearUserCodeSearch}
        fontSize="12.5px"
      />
      <InputWithLabelSection>
        <FilterLabel>{t('status')}</FilterLabel>
        <Select
          isSearchable
          value={selectedStatus}
          options={statusOptions}
          placeholder={t('select_status')}
          onChange={e => {
            setSelectedStatus(e);
            props.onStatusChange(e);
          }}
          styles={CreateProjectDropdown()}
        />
      </InputWithLabelSection>

      {/* if the user is admin then he can apply the filter */}
      {localStorage.getItem('user_role') === 'admin' && selectedMembers.length > 0 ? (
        <InputWithLabelSection>
          <FilterLabel>{t('action_type')}</FilterLabel>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Select
              isSearchable
              value={selectedEmployeeType}
              options={employeeTypeOptions}
              placeholder={t('select_employee_type')}
              onChange={e => {
                setSelectedEmployeeType(e);
              }}
              styles={CreateProjectDropdown()}
            />
            {selectedMembers?.length > 0 && selectedEmployeeType && (
              <ColoredButtonWithIcon
                disabled={bulkUpdateFromPendingRequestsLoading}
                onClick={() => {
                  handleApplyFilter();
                }}
              >
                {bulkUpdateFromPendingRequestsLoading ? (
                  <ButtonTextLoader loadingText={t('requesting')} fontSize="13px" />
                ) :
                  <>
                    <ButtonIcon src={tickIcon} />
                    {t('apply')}
                  </>
                }
              </ColoredButtonWithIcon>
            )}
          </div>
        </InputWithLabelSection>
      ) : ["gm", "agm"].includes(localStorage.getItem('user_role')) && selectedMembers.length > 0 && (
        <InputWithLabelSection>
          <FilterLabel>{t('cancel_selected_requests')}</FilterLabel>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <ColoredButtonWithIcon
              disabled={bulkUpdateFromPendingRequestsLoading}
              onClick={() => {
                handleApplyFilter("reject");
              }}
            >
              {bulkUpdateFromPendingRequestsLoading ? (
                <ButtonTextLoader loadingText={t('requesting')} fontSize="13px" />
              ) : (
                <>
                  <ButtonIcon src={crossIcon} />
                  {t('cancel_request')}
                </>
              )}
            </ColoredButtonWithIcon>
          </div>
        </InputWithLabelSection>
      )}
    </FilterContainer>
  );
};

export default PendingFilters;
